import type { MappedAuthUser } from "./mapWorkosUserProfile";

type UserLike = Pick<
  MappedAuthUser,
  "email" | "name" | "fullname" | "first_name" | "last_name" | "display_name"
>;

/** Stable label for avatars and chat — prefers structured identity over legacy demo names. */
export function userDisplayName(user: UserLike | null | undefined): string {
  if (!user) return "You";

  const structured = [user.first_name, user.last_name]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(" ");
  if (structured) return structured;

  const displayName = user.display_name?.trim();
  if (displayName) return displayName;

  const fullname = user.fullname?.trim();
  if (fullname) return fullname;

  const name = user.name?.trim();
  if (name) return name;

  const emailLocal = user.email?.split("@")[0]?.trim();
  if (emailLocal) return emailLocal;

  return "You";
}

export function userAvatarSeed(user: UserLike | null | undefined): string {
  return userDisplayName(user);
}
